import { render, staticRenderFns } from "./changePackage.vue?vue&type=template&id=c5990090&"
import script from "./changePackage.vue?vue&type=script&lang=js&"
export * from "./changePackage.vue?vue&type=script&lang=js&"
import style0 from "./changePackage.vue?vue&type=style&index=0&id=c5990090&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports